document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".exp__dd-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const dateText = this.textContent.trim(); // Full string
      const parsed = parseExperienceDate(dateText);

      console.log("📅 Experience clicked:", parsed);

      // Save full string and parsed version
      sessionStorage.setItem("selectedExperienceTime", dateText);
      sessionStorage.setItem("selectedExperienceDate", parsed.date);
      sessionStorage.setItem("selectedExperienceTimeOnly", parsed.time);
    });
  });
});

function parseExperienceDate(str) {
  const parts = str.split("|").map(p => p.trim());
  return {
    date: parts[0],        // "Oct 4"
    time: parts[1],        // "2:00pm EDT"
    spotsLeft: parts[2]    // "16 Left"
  };
}


